export const title = {
    esp:"EN PROCESO",
    por:"EM BREVE",
};

export const subTitle = {
    esp:"VUELVA PRONTO",
    por:"VOLTE LOGO",
};